module.exports = __webpack_public_path__ + "img/match-7.d2b55ddc.webp";